import React from 'react';

const NewCompanyForm = ({
  showCompanyForm,
  newCompanyData,
  setNewCompanyData,
  handleAddNewCompany,
  setShowCompanyForm
}) => {
  if (!showCompanyForm) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Add New Company</h3>
        <div className="modal-form">
          <div className="form-group">
            <label>Company Name*:</label>
            <input
              type="text"
              value={newCompanyData.name}
              onChange={(e) => setNewCompanyData({
                ...newCompanyData,
                name: e.target.value
              })}
              required
            />
          </div>
          
          <div className="form-group">
            <label>Industry:</label>
            <input
              type="text"
              value={newCompanyData.industry}
              onChange={(e) => setNewCompanyData({
                ...newCompanyData,
                industry: e.target.value
              })}
            />
          </div>
          
          <div className="form-group">
            <label>Website:</label>
            <input
              type="url"
              value={newCompanyData.website}
              onChange={(e) => setNewCompanyData({
                ...newCompanyData,
                website: e.target.value
              })}
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>City:</label>
              <input
                type="text"
                value={newCompanyData.city}
                onChange={(e) => setNewCompanyData({
                  ...newCompanyData,
                  city: e.target.value
                })}
              />
            </div>
            
            <div className="form-group">
              <label>State:</label>
              <input
                type="text"
                value={newCompanyData.state}
                onChange={(e) => setNewCompanyData({
                  ...newCompanyData,
                  state: e.target.value
                })}
              />
            </div>
          </div>
          
          <div className="form-group">
            <label>Country:</label>
            <input
              type="text"
              value={newCompanyData.country}
              onChange={(e) => setNewCompanyData({
                ...newCompanyData,
                country: e.target.value
              })}
            />
          </div>
          
          <div className="modal-buttons">
            <button 
              onClick={handleAddNewCompany}
              disabled={!newCompanyData.name.trim()}
            >
              Save
            </button>
            <button onClick={() => setShowCompanyForm(false)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCompanyForm;
